export const DateRangeValues = {
    _3days: 3,
    _7days: 7,
    _14days: 14,
    _30days: 30,
    _3months: 90,
    _6months: 180,
    _year: 365,
    calendar: 'calendar',
};

export enum DateDropdownOptions {
    Calendar = 'calendar',
    Last3days = '3',
    Last7days = '7',
    Last14days = '14',
    Last30days = '30',
    Last35days = '35',
    Last3months = '90',
    Last6months = '180',
    Last12months = '365',
    All = 'all',
}
